// extracted by mini-css-extract-plugin
module.exports = {"msaSection":"Forms_msaSection__k7mIT","statusFilter":"Forms_statusFilter__3ua0L","other":"Forms_other__2tKx0"};